import React, { useRef } from "react";
import { toQuery } from "../helpers/general";
import { useCookie } from "../hooks/useCookie";
import apiService from "../service/apiService";
import { AsyncPaginate } from "react-select-async-paginate";
import { colors } from "../config/theme";

const InfiniteScrollSelect = React.forwardRef((props: any, ref) => {
  const {
    url,
    isSearchable = true,
    isLoading = false,
    defaultValue = "",
    // query = "",
    onChange = null,
    onSelect,
    placeholder = "Choisissez une option",
    formatOptions,
    value: controlledValue,
    ...rest
  } = props;

  const { token } = useCookie("vToken");
  const selectRef = useRef();

  async function loadOptions(
    search: string,
    loadedOptions: any[],
    additional: any,
  ) {
    const page = additional?.page || 1;

    const endpoint = `${url.path}${toQuery({
      page,
      limit: 10,
      q: search,
    })}`;

    const response = await apiService.MakeGetRequest(endpoint, token);

    const items = Array.isArray(response) ? response : response?.items || [];
    const totalPages = response?.meta?.totalPages || 1;

    return {
      options: items,
      hasMore: page < totalPages,
      additional: {
        page: page + 1,
      },
    };
  }

  // async function loadOptions(search: string, options: any[], additional: any) {
  //   try {
  //     if (defaultValue) {
  //       setSelectedOption(defaultValue);
  //       setLoading(false);
  //       return {
  //         options: [defaultValue],
  //         hasMore: false,
  //         additional: {
  //           currentPage: 1,
  //           nextPage: 2
  //         }
  //       };
  //     }
  //     setLoading(true);
  //     const endpoint = `${url.path}${toQuery({
  //       page: additional?.nextPage || 1,
  //       limit: 10,
  //       q: query || search
  //     })}`;

  //     const response = await apiService.MakeGetRequest(endpoint, token);
  //     const totalPages = response?.meta?.totalPages || 1;

  //     const currentPage = additional?.nextPage || 1;
  //     const fetchedOptions = response?.items || response || [];
  //     const formattedOptions = formatOptions
  //       ? formatOptions(fetchedOptions)
  //       : fetchedOptions;
  //     return {
  //       options: formattedOptions,
  //       hasMore: totalPages > currentPage,
  //       additional: {
  //         currentPage,
  //         nextPage: currentPage + 1
  //       }
  //     };
  //   } catch (error) {
  //     setLoading(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  return (
    <AsyncPaginate
      value={controlledValue !== undefined ? controlledValue : defaultValue || null}
      loadOptions={loadOptions}
      onChange={async (option) => {
        onChange && onChange(option);
        onSelect && onSelect(option);
      }}
      placeholder={placeholder}
      isLoading={isLoading}
      isSearchable={isSearchable}
      isMulti={false}
      maxMenuHeight="200px"
      minMenuHeight="200px"
      loadingMessage={() => <p>Chargement...</p>}
      filterOption={(option, searchValue) => {
        const value = option?.label || option?.name;
        return value?.toLowerCase().includes(searchValue?.toLowerCase());
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: colors.primary,
        },
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          boxShadow: state.isFocused
            ? "rgb(129, 227, 249) 0rem 0rem 0rem 0.125rem"
            : "none",
          minWidth: 0,
        }),

        valueContainer: (base) => ({
          ...base,
          overflow: "hidden",
          flexWrap: "nowrap",
          maxWidth: "100%",
        }),

        input: (base) => ({
          ...base,
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: "0",
        }),

        singleValue: (base) => ({
          ...base,
          maxWidth: "calc(100% - 20px)",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }),

        placeholder: (base) => ({
          ...base,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "100%",
        }),

        // NO truncation on menu and options - they can expand/wrap normally
        menu: (base) => ({
          ...base,
          minWidth: "100%",
          width: "max-content",
          maxWidth: "400px", // Optional: limit max width
          zIndex: 9999,
        }),

        option: (base) => ({
          ...base,
          whiteSpace: "normal", // Allow wrapping
          overflow: "visible",
          wordBreak: "break-word",
        }),
      }}
      menuPosition={"absolute"}
      menuPortalTarget={document.body}
      cacheUniqs={[url.path]}
      selectRef={selectRef}
      // onChange
      defaultInputValue={defaultValue?.title ?? ""}
      {...rest}
    />
  );
});

export default InfiniteScrollSelect;
